import { render } from "./pages.vue?vue&type=template&id=33215f30&scoped=true"
import script from "./pages.vue?vue&type=script&lang=js"
export * from "./pages.vue?vue&type=script&lang=js"

import "./pages.vue?vue&type=style&index=0&id=33215f30&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33215f30"]])

export default __exports__